import React, {PureComponent} from "react"
import Joyride, {Props as JoyrideProps, CallBackProps, ACTIONS, STATUS, EVENTS} from "react-joyride"

import tourTracking from "@irati-tracking/tour"
import theme from "@irati/ui/src/global/theme"
import TourStep from "../../index"
import CustomToolTip from "./CustomToolTip"
import CustomBeacon from "./CustomBeacon"

interface Props extends JoyrideProps {
  tourPrefix: string
  onStart?: () => void
  onComplete?: () => void
  onClose?: () => void
  steps: TourStep[]
}

const customStyles = {
  options: {
    primaryColor: theme.colors.perkbox.darkBlue
  }
}

// See ./README.md for implementation suggestion and doc links
class PerkboxTour extends PureComponent<Props> {
  customCallback = (data: CallBackProps) => {
    const {status, action, type} = data
    const {onStart, onComplete, onClose, tourPrefix, steps} = this.props

    if (action === ACTIONS.START && type === EVENTS.TOUR_START) {
      tourTracking.tourStart(tourPrefix, steps.length)
      if (onStart) onStart()
    }
    if (status === STATUS.FINISHED && type === EVENTS.STEP_AFTER) {
      tourTracking.tourComplete(tourPrefix, steps.length)
      if (onComplete) onComplete()
    }
    if (action === ACTIONS.PREV && type === EVENTS.STEP_BEFORE) {
      tourTracking.tourPrevious(tourPrefix, data.index, data.size)
    }
    if (action === ACTIONS.NEXT && type === EVENTS.STEP_BEFORE) {
      tourTracking.tourNext(tourPrefix, data.index, data.size)
    }
    if (action === ACTIONS.CLOSE && type === EVENTS.STEP_BEFORE) {
      tourTracking.tourClose(tourPrefix, data.index, data.size)
      if (onClose) onClose()
    }
  }

  render() {
    return (
      <Joyride
        beaconComponent={CustomBeacon}
        tooltipComponent={CustomToolTip}
        continuous
        scrollToFirstStep
        callback={this.customCallback}
        showProgress
        showSkipButton
        {...this.props}
        styles={customStyles}
      />
    )
  }
}

export default PerkboxTour
